import { Component, Inject, Input, OnInit, Output, EventEmitter } from 'ng-metadata/core';
import { PhysicalBestOfferService } from './physicalBestOffer.service';
import { NgrsService } from '../ngrs.service';
import { getResourceType } from '../../../../infra/ngrsUtil';
import { LoginService } from '../../../../security/login/login.service';
import { JwtUtilService } from "../../../../security/jwtUtil.service";
import { beacon, PrimolyticsService } from '../../../../analytics/primolytics.service';
import { includes } from 'lodash';
import { PickupAnywhereService } from '../pickup-anywhere-form/pickupAnywhereForm.service';
import {
    getRapidoAllowPhysicalRequestForEbookOffer,
    isShowPhysicalJournalOffer
} from '../../../../appConfig/appConfigForward';



const HOME_DELIVERY = "homeDelivery";
const OFFICE_DELIVERY = "officeDelivery";

@Component({
    "inputs": ['piclocs', 'showmessagebar'],
    "selector": "prm-service-physical-best-offer",
    templateUrl: 'components/search/fullView/ngrs/physicalBestOffer/physicalBestOffer.html'
})

export class PrmServicePhysicalBestOffer implements OnInit {

    @Input() item: Object;
    @Input() private opendigitalform: Object;
    @Input() private openphysicalform: Object;
    @Input() private openblankform: Object;
    @Input() private bestoffer: Object;
    @Input() private bestebookoffer: Object;
    @Input() private isdigitaloffer: boolean;
    @Input() private digitalbestoffer: Object;
    @Input() private showmoredeliveryoptions: Object;
    @Input() private issubmitdigital: Object;
    @Input() private pickupanywhereplaceholder: string;
    @Input() private pickupinformationalreadyselected: boolean;
    @Input() private cannotcalculateoffer: boolean;
    @Input() private tilesplaceholderactive: boolean;
    @Input() private noofferfound: boolean;
    @Input() private threeoffers: boolean;
    @Output() private showPickupAnywhereForm = new EventEmitter();

    private _requestSubmitted = false;

    private _showPickupAnywhere = false;
    private allowPhysicalRequestForEbook = false;

    constructor(private physicalBestOfferService: PhysicalBestOfferService,
        private loginService: LoginService,
        private jwtUtilService: JwtUtilService,
        private primolyticsService: PrimolyticsService,
        private pickupAnywhereService: PickupAnywhereService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$translate') private $translate) {
            if(window.appConfig['system-configuration'].ngrs_pickup_anywhere){
                this._showPickupAnywhere = true;
            }
        this.allowPhysicalRequestForEbook = getRapidoAllowPhysicalRequestForEbookOffer();
    }

    ngOnInit() {
    }


    public getItRequest() {
        this.showmessagebar.showMessageBar = false;
        if (this.allowPhysicalRequestForEbook && this.bestebookoffer && this.bestebookoffer.ebookOffer) {
            this.openblankform.openBlankForm = false;
            this.opendigitalform.openDigitalForm = false;
            this.openphysicalform.openPhysicalForm = true;
            this.openphysicalform.isEbook = true;
        }
        else if (!this.isdigitaloffer) {
            this.openblankform.openBlankForm = false;
            this.opendigitalform.openDigitalForm = false;
            this.openphysicalform.openPhysicalForm = true;
            this.openphysicalform.isEbook = false;
        } else if (this.isdigitaloffer) {
            this.openblankform.openBlankForm = false;
            this.opendigitalform.openDigitalForm = true;
            this.openphysicalform.openPhysicalForm = false;
            this.openphysicalform.isEbook = false;
        } else {
            this.openblankform.openBlankForm = true;
            this.opendigitalform.openDigitalForm = false;
            this.openphysicalform.openPhysicalForm = false;
            this.issubmitdigital.isSubmitDigital = false;
            this.openphysicalform.isEbook = false;
            if (this.isdigitaloffer) {
                this.issubmitdigital.isSubmitDigital = true;
            }
        }
        this.$timeout(() => {
            let element = document.querySelector('#item-ngrs') as HTMLElement;
            if (element) {
                element.focus();
            }
        }, 100);
    }

    public isShowBestOffer() {
        return !this.openphysicalform.openPhysicalForm;
    }

    public getSupplyTime() {
        return this.isDigitalOffer() ? this.digitalbestoffer.supplyTime : this.bestoffer.supplyTime;
    }

    public isShowPatronCost(){
        if(this.digitalbestoffer){
            return this.digitalbestoffer.hasOwnProperty('patronCost') && typeof this.digitalbestoffer.patronCost != "undefined" && typeof this.digitalbestoffer.currency != "undefined";
        }
        return this.bestoffer.hasOwnProperty('patronCost') && typeof this.bestoffer.patronCost != "undefined" && typeof this.bestoffer.currency != "undefined";
    }

    public dontShowAnyOfferTile() {
        return this.isTilesPlaceholderActive() || this.isNoOfferFound();
    }

    public isTilesPlaceholderActive(){
        return this.tilesplaceholderactive;
    }

    public isNoOfferFound(){
        return this.noofferfound;
    }

    public getPatronCost(){
        if(this.digitalbestoffer){
            return this.digitalbestoffer.patronCost;
        }
        return this.bestoffer.patronCost;
    }

    public getCurrency(){
        if(this.digitalbestoffer){
            return this.digitalbestoffer.currency
        }
        return this.bestoffer.currency;
    }

    public getLoanPeriod() {
        return this.bestoffer.loanPeriod;
    }

    public isDigitalOffer() {
        return this.isdigitaloffer;
    }

    public getResourceType() {
        return getResourceType(this.item);
    }

    public isSignedIn() {
        return this.jwtUtilService.isSignedIn();
    }

    public isSelfRegistered() {
        return this.jwtUtilService.isSelfRegistered();
    }

    @beacon({ 'p': 'general', 'op': 'signIn' })
    public signIn() {
        this.loginService.handleLoginClick();
        this.loginService.sendAnalytics('manually');
    }

    recieveSubmitEvent(event) {
        this._requestSubmitted = true;
    }

    public getShowForm() {
        return this._openBlankForm.openBlankForm;
    }

    public rapidoRota(): boolean {
        return this.bestoffer && this.bestoffer.rotaId;
    }

    public showOfferTile() {
        return ((!this.isdigitaloffer && this.bestoffer && ((!this.bestoffer.rotaId || this.bestoffer.rapidRRota) || this.showOfferTileForRota())) || (this.isdigitaloffer && this.digitalbestoffer));
    }

    public getTileClass(){
        if(this._showPickupAnywhere && this.isDigitalOffer()){
            return 'get_it_btn_digital';
        }else if(this._showPickupAnywhere && !this.isDigitalOffer()){
            return 'get_it_btn_physical';
        }else{
            return 'get_it_btn';
        }
    }

    public openPickupAnywhereForm() {
        this.showPickupAnywhereForm.emit('true');
    }

    public getPickupAnywhereSelectedLocation(){
        if(this.pickupanywhereplaceholder){
            return this.pickupanywhereplaceholder;
        }
        return this.$translate.instant('nui.ngrs.pickup.information.selectPickupInformation');
    }

    public pickupInformationSelected(){
        if(this.pickupAnywhereService.getSelectedPickupInformation() && this.pickupAnywhereService.getSelectedPickupInformation().chosenPlaceRadio){
            return true;
        }
        return this.pickupinformationalreadyselected;
    }

    public isPersonalDelivery() {
        return this.pickupAnywhereService.getSelectedPickupInformation() && 
        (this.pickupAnywhereService.getSelectedPickupInformation().chosenPlaceRadio === HOME_DELIVERY ||
        this.pickupAnywhereService.getSelectedPickupInformation().chosenPlaceRadio === OFFICE_DELIVERY);
    }

    public isGetItButtonDisabled(){
        if(!this._showPickupAnywhere || this.isdigitaloffer){
            return false;
        }
        if(!this.pickupAnywhereService.getSelectedPickupInformation() || !this.pickupAnywhereService.getSelectedPickupInformation().chosenPlaceRadio){
            return this.cannotcalculateoffer || !this.pickupinformationalreadyselected;
        }
        return this.cannotcalculateoffer;
    }

    public showPickupInstitutionOfferDetails(){
        if(this.isdigitaloffer){
            return true;
        }
        return this.pickupInformationSelected() && !this.cannotcalculateoffer;
    }

    
    public getButtonAriaLable(){
        let ariaLable = this.$translate.instant("nui.ngrs.nooffer.getit") + " - ";
        let resourceType = getResourceType(this.item);
        if(resourceType == 'journal'  || resourceType == 'ejournal'){
            ariaLable += this.$translate.instant("nui.ngrs.rapido.offer.details.journalCopy");
        }else if(!this.isDigitalOffer()){
            ariaLable += this.$translate.instant("nui.ngrs.rapido.rota.offer.details.physicalCopy");
        }else if(resourceType == 'book'){
            ariaLable += this.$translate.instant("nui.ngrs.rapido.offer.details.digitalChapter");
        }else{
            ariaLable += this.$translate.instant("nui.ngrs.rapido.offer.details.digitalCopy");
        }
        return ariaLable;
    }

    private showOfferTileForRota() {
        return (this.bestoffer.rotaId && (this.bestoffer.loanPeriod || this.bestoffer.supplyTime))
    }

    public isSupplyTime(){
        return this.bestoffer.supplyTime;
    }

    public isLoanPeriod(){
        return this.bestoffer.loanPeriod;
    }

    public isUnavailableResource(){
        if(!this.bestoffer || typeof this.bestoffer.unavailableResource === 'undefined'){
            return false;
        }
        return this.bestoffer.unavailableResource;
    }

    public isJournal(){
        let resourceType = getResourceType(this.item);
        if(resourceType == 'journal' || resourceType == 'ejournal'){
            return true;
        }
        return false;
    }

    public isPhysicalJournal(){
        let resourceType = getResourceType(this.item);
        if(resourceType == 'journal' && isShowPhysicalJournalOffer()){
            return true;
        }
        return false;
    }

    public isShowPhysicalJournalOffer(){
        return isShowPhysicalJournalOffer();
    }

    public isEbookOffer(){
        if (this.allowPhysicalRequestForEbook && this.bestebookoffer && this.bestebookoffer.ebookOffer) {
            return true;
        }
        if (this.bestoffer && !!!this.bestoffer.ebookOffer) {
            return false;
        }
        return this.bestoffer && this.bestoffer.ebookOffer;
    }

    public isPuaOffer(){
        return this.bestoffer.puaCentralMembers != undefined && Object.keys(this.bestoffer.puaCentralMembers).length > 0 && !this.isEbookOffer();
    }

    public digitalTile() {
        return this.isDigitalOffer() && this.getResourceType() !== 'book' && !this.isJournal();
    }

    public digitalChapter() {
        return this.isDigitalOffer() && this.getResourceType() === 'book';
    }

    public digitalJournal() {
        return this.isDigitalOffer() && this.isJournal();
    }
}










// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/physicalBestOffer/physicalBestOffer.directive.ts